import { useEffect, useState } from "react";
import axiosClient from "../../axios-client";

function DebugHeaders() {

    const [headers, setHeaders] = useState();


    useEffect(()=>{
        (async ()=>{
            const headers = await getHeaders();
            console.log("headers", headers);
            setHeaders(headers);
        })();
    }, []);

    async function getHeaders(): Promise<any> {
        const response = await axiosClient.get(`/api/debug-headers`);
        return response.data;
    }


    return (
        <>
            <pre style={{direction: "ltr", textAlign: "left", overflow: "auto"}}>{JSON.stringify(headers, null, 2)}</pre>

        </>
    );
}

export default DebugHeaders;
